<template>
   <v-container fluid class="webcall">
    <AccessIframe :path="'/createOrder'" />
  </v-container>
</template>

<script>
import AccessIframe from 'components/accessIframe/AccessIframe'

export default {
  name: 'EntregaCall',
  components: {
    AccessIframe
  },
  data () {
    return {
      namespace: 'Views.EntregaCall'
    }
  },
  computed: {

  },

  methods: {
    // TODO
  },

  mounted () {
    // TODO
  }
}
</script>

<style lang="scss">
.application.theme--light.logged.route--entregacall {
  .v-content {
    padding-top: 0 !important;
  }
  .corp-header {

    > .v-toolbar--fixed,
    .corp-header--mobile {
      display: none;
    }
  }
}
.no-main-menu-from-v4.application {
  .v-content {
    padding-top: 0 !important;
  }
}
</style>
